<template>
	<section>
        
		<div class="container-fluid">
			<div class="row">
				<div class="col-12">
					
            <div class="section-title">
                PROGRAMS
            </div>
            <div class="row">
                <div class="col-12 col-sm-6 col-lg-4 col-xl-3 d-flex">
	                <div class="banner d-flex">
	                	<a href="#" class="d-flex justify-content-center align-items-center">
		                	<div class="thumb-container" style="background-image: url(http://dev.sozpic.com/maquetas/nevvon/assets/images/demo/item1.jpg);"></div>
		                	<div class="caption">
			                	<div class="title">Program 1</div>
			                	<div class="subtitle">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris eleifend elit non metus maximus, nec tincidunt dui aliquet. Mauris iaculis sapien id cursus facilisis.</div>
		                	</div><!--caption-->
	                	</a>
	                </div>
                </div><!--col-->
                <div class="col-12 col-sm-6 col-lg-4 col-xl-3 d-flex">
	                <div class="banner d-flex">
	                	<a href="#" class="d-flex justify-content-center align-items-center">
		                	<div class="thumb-container" style="background-image: url(http://dev.sozpic.com/maquetas/nevvon/assets/images/demo/item2.jpg);"></div>
		                	<div class="caption">
			                	<div class="title">Program 2</div>
			                	<div class="subtitle">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris eleifend elit non metus maximus, nec tincidunt dui aliquet. Mauris iaculis sapien id cursus facilisis.</div>
		                	</div><!--caption-->
	                	</a>
	                </div>
                </div><!--col-->
                <div class="col-12 col-sm-6 col-lg-4 col-xl-3 d-flex">
	                <div class="banner d-flex">
	                	<a href="#" class="d-flex justify-content-center align-items-center">
		                	<div class="thumb-container" style="background-image: url(http://dev.sozpic.com/maquetas/nevvon/assets/images/demo/item3.jpg);"></div>
		                	<div class="caption">
			                	<div class="title">Program 3</div>
			                	<div class="subtitle">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris eleifend elit non metus maximus, nec tincidunt dui aliquet. Mauris iaculis sapien id cursus facilisis.</div>
		                	</div><!--caption-->
	                	</a>
	                </div>
                </div><!--col-->
                <div class="col-12 col-sm-6 col-lg-4 col-xl-3 d-flex">
	                <div class="banner d-flex">
	                	<a href="#" class="d-flex justify-content-center align-items-center">
		                	<div class="thumb-container" style="background-image: url(http://dev.sozpic.com/maquetas/nevvon/assets/images/demo/item4.jpg);"></div>
		                	<div class="caption">
			                	<div class="title">Program 4</div>
			                	<div class="subtitle">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris eleifend elit non metus maximus, nec tincidunt dui aliquet. Mauris iaculis sapien id cursus facilisis.</div>
		                	</div><!--caption-->
	                	</a>
	                </div>
                </div><!--col-->
                 <div class="col-12 col-sm-6 col-lg-4 col-xl-3 d-flex">
	                <div class="banner d-flex">
	                	<a href="#" class="d-flex justify-content-center align-items-center green-content">
		                	<div class="caption">
			                	<div class="title">Add new program</div>
			                	<div class="subtitle text-center"><img src="http://dev.sozpic.com/maquetas/nevvon/assets/images/icon_plus_circle_white.svg" width="50" /></div>
		                	</div><!--caption-->
	                	</a>
	                </div>
                </div><!--col-->
            </div><!--row-->
            <div class="section-title">
                Admin Dashboard
            </div>

            <div class="content">
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer suscipit, neque et mattis viverra, augue lacus scelerisque turpis, in accumsan metus turpis sit amet nisl. Duis feugiat odio et mauris convallis, sit amet scelerisque felis tincidunt. Aliquam bibendum accumsan elit ut sagittis. Quisque id venenatis diam, at ornare nisi. Fusce tincidunt faucibus velit, eu maximus turpis scelerisque at. Pellentesque fringilla est sed maximus consequat. Duis arcu magna, porta sit amet condimentum eu, sagittis sed neque. Curabitur eleifend, metus vitae dictum suscipit, diam augue fermentum est, a placerat enim sapien a tellus. Vivamus vel tellus dapibus, hendrerit eros a, ullamcorper ex. Sed volutpat sem in molestie porttitor. Nullam euismod nunc a nibh consequat, sit amet bibendum metus luctus. Sed sagittis at est posuere scelerisque. Curabitur elementum condimentum nisi eu placerat.</p>

                <p>Donec mauris lacus, ornare eu pellentesque nec, malesuada ac nisl. Donec gravida placerat luctus. Nullam mattis orci et viverra feugiat. Sed convallis neque tortor, et hendrerit mauris mattis lacinia. In varius leo non risus consectetur vulputate. Phasellus vitae interdum elit. Phasellus in pellentesque nulla. Nulla facilisi. Vestibulum eget ex eros.</p>

                <p>Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Nullam cursus vestibulum dui, nec luctus metus posuere eu. Etiam eleifend lectus est, eu pretium orci imperdiet eu. Morbi ornare eu elit ut porta. Phasellus vitae tellus blandit dolor dictum hendrerit vel ut ligula. Vivamus ornare sem ac nisl efficitur placerat ac quis ante. Vivamus dictum tellus felis, vel placerat orci faucibus sed. Suspendisse a justo vel metus auctor egestas a ac dui. Cras lobortis nunc vitae convallis lacinia. Suspendisse mollis ligula ipsum, ut molestie sem congue non. Cras auctor eu lorem non venenatis. Praesent venenatis, justo eu euismod tempus, quam nunc ultricies nisl, eget iaculis tellus urna non tellus. Nullam aliquam ut nisi ut accumsan.</p>
            </div>

            <div class="section-title">
                HHAs
            </div>

				<div class="row">
					<div class="col-12">
						<div class="table-responsive">
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col" class="green-content">#</th>

                            <th scope="col" class="green-content">First</th>

                            <th scope="col" class="green-content">Last</th>

                            <th scope="col" class="green-content">Handle</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <th scope="row">1</th>

                            <td>Mark</td>

                            <td>Otto</td>

                            <td>@mdo</td>
                        </tr>

                        <tr>
                            <th scope="row">2</th>

                            <td>Jacob</td>

                            <td>Thornton</td>

                            <td>@fat</td>
                        </tr>

                        <tr>
                            <th scope="row">3</th>

                            <td>Larry</td>

                            <td>the Bird</td>

                            <td>@twitter</td>
                        </tr>
                        <tr>
                            <th scope="row">1</th>

                            <td>Mark</td>

                            <td>Otto</td>

                            <td>@mdo</td>
                        </tr>

                        <tr>
                            <th scope="row">2</th>

                            <td>Jacob</td>

                            <td>Thornton</td>

                            <td>@fat</td>
                        </tr>

                        <tr>
                            <th scope="row">3</th>

                            <td>Larry</td>

                            <td>the Bird</td>

                            <td>@twitter</td>
                        </tr>
                    </tbody>
                </table>
            </div><!--table_responsive-->
					</div><!--col-->
				</div><!--row-->

            <div class="section-title">
                PEOPLE
            </div>

            <ul class="users d-flex flex-wrap">
                <li>
                    <div>
                        <div class="thumb-container" style="background-image: url(http://dev.sozpic.com/maquetas/nevvon/assets/images/sv.jpg);"></div>

                        <div class="title">
                            Lorem ipsum
                        </div>

                        <div class="subtitle">
                            Lorem ipsum dolor Lorem ipsum dolor
                        </div><a href="assets/#" class="button">View</a>
                    </div>
                </li>

                <li>
                    <div>
                        <div class="thumb-container" style="background-image: url(http://dev.sozpic.com/maquetas/nevvon/assets/images/sv.jpg);"></div>

                        <div class="title">
                            Lorem ipsum
                        </div>

                        <div class="subtitle">
                            Lorem ipsum dolor Lorem ipsum dolor
                        </div><a href="assets/#" class="button">View</a>
                    </div>
                </li>

                <li>
                    <div>
                        <div class="thumb-container" style="background-image: url(http://dev.sozpic.com/maquetas/nevvon/assets/images/sv.jpg);"></div>

                        <div class="title">
                            Lorem ipsum
                        </div>

                        <div class="subtitle">
                            Lorem ipsum dolor Lorem ipsum dolor
                        </div><a href="assets/#" class="button">View</a>
                    </div>
                </li>

                <li>
                    <div>
                        <div class="thumb-container" style="background-image: url(http://dev.sozpic.com/maquetas/nevvon/assets/images/sv.jpg);"></div>

                        <div class="title">
                            Lorem ipsum
                        </div>

                        <div class="subtitle">
                            Lorem ipsum dolor Lorem ipsum dolor
                        </div><a href="assets/#" class="button">View</a>
                    </div>
                </li>

                <li>
                    <div>
                        <div class="thumb-container" style="background-image: url(http://dev.sozpic.com/maquetas/nevvon/assets/images/sv.jpg);"></div>

                        <div class="title">
                            Lorem ipsum
                        </div>

                        <div class="subtitle">
                            Lorem ipsum dolor Lorem ipsum dolor
                        </div><a href="assets/#" class="button">View</a>
                    </div>
                </li>

                <li>
                    <div>
                        <div class="thumb-container" style="background-image: url(http://dev.sozpic.com/maquetas/nevvon/assets/images/sv.jpg);"></div>

                        <div class="title">
                            Lorem ipsum
                        </div>

                        <div class="subtitle">
                            Lorem ipsum dolor Lorem ipsum dolor
                        </div><a href="assets/#" class="button">View</a>
                    </div>
                </li>

                <li>
                    <div>
                        <div class="thumb-container" style="background-image: url(http://dev.sozpic.com/maquetas/nevvon/assets/images/sv.jpg);"></div>

                        <div class="title">
                            Lorem ipsum
                        </div>

                        <div class="subtitle">
                            Lorem ipsum dolor Lorem ipsum dolor
                        </div><a href="assets/#" class="button">View</a>
                    </div>
                </li>

                <li>
                    <div>
                        <div class="thumb-container" style="background-image: url(http://dev.sozpic.com/maquetas/nevvon/assets/images/sv.jpg);"></div>

                        <div class="title">
                            Lorem ipsum
                        </div>

                        <div class="subtitle">
                            Lorem ipsum dolor Lorem ipsum dolor
                        </div><a href="assets/#" class="button">View</a>
                    </div>
                </li>

                <li>
                    <div>
                        <div class="thumb-container" style="background-image: url(http://dev.sozpic.com/maquetas/nevvon/assets/images/sv.jpg);"></div>

                        <div class="title">
                            Lorem ipsum
                        </div>

                        <div class="subtitle">
                            Lorem ipsum dolor Lorem ipsum dolor
                        </div><a href="assets/#" class="button">View</a>
                    </div>
                </li>

                <li>
                    <div>
                        <div class="thumb-container" style="background-image: url(http://dev.sozpic.com/maquetas/nevvon/assets/images/sv.jpg);"></div>

                        <div class="title">
                            Lorem ipsum
                        </div>

                        <div class="subtitle">
                            Lorem ipsum dolor Lorem ipsum dolor
                        </div><a href="assets/#" class="button">View</a>
                    </div>
                </li>
            </ul>
            <ul class="pagination justify-content-center">
                <li class="active"><a href="#">1</a></li>
                <li><a href="#">3</a></li>
                <li><a href="#">4</a></li>
                <li><a href="#">5</a></li>
                <li><a href="#">6</a></li>
            </ul>
            
            <div class="section-title">TEAM DATA</div>
            <div class="row">
                <div class="col-12 col-lg-6">
	                <div class="profile-presentation mb-5">
		                <div class="row">
			                <div class="col-12 col-sm-6">
								<div class="thumb-container pb-100 profile-thumb" style="background-image: url(http://dev.sozpic.com/maquetas/nevvon/assets/images/sv.jpg);"></div>
			                </div><!--col-->
			                <div class="col-12 col-sm-6">
				                <ul class="icon-list list-unstyled">
					                <li class="d-flex align-items-center mb-2 ">
					                	<span class="mr-2"><img src="http://dev.sozpic.com/maquetas/nevvon/assets/images/icons/solid/user_green.svg" width="22" /></span>
					                	<span>Name: <strong>John Doe</strong></span>
					                </li>
					                <li class="d-flex align-items-center mb-2">
					                	<span class="mr-2"><img src="http://dev.sozpic.com/maquetas/nevvon/assets/images/icons/solid/phone_green.svg" width="22" /></span>
					                	<span>Telephone: <strong>555-6789</strong></span>
					                </li>
					                <li class="d-flex align-items-center mb-2">
					                	<span class="mr-2"><img src="http://dev.sozpic.com/maquetas/nevvon/assets/images/icons/solid/globe_green.svg" width="22" /></span>
					                	<span>Language: <strong>English</strong></span>
					                </li>
					                <li class="d-flex align-items-center mb-2">
					                	<span class="mr-2"><img src="http://dev.sozpic.com/maquetas/nevvon/assets/images/icons/solid/trophy_green.svg" width="22" /></span>
					                	<span>Rank: <strong>27</strong></span>
					                </li>
					                <li class="d-flex align-items-center mb-2">
					                	<span class="mr-2"><img src="http://dev.sozpic.com/maquetas/nevvon/assets/images/icons/solid/map-marker_green.svg" width="22" /></span>
					                	<span>Address: <strong>Street</strong></span>
					                </li>
				                </ul>
				                <div class="row align-content-center">
					                <div class="col-12">
						                <a class="button w-100 icon-button" href="#">
							                <img src="http://dev.sozpic.com/maquetas/nevvon/assets/images/icon_envelope_white.svg" class="mr-1" width="18" />
							                <span>Send message</span>
						                </a>
					                </div><!--col-->
					                <div class="col-12">
					               		<a class="align-items-center button d-flex dark-button justify-content-center w-100" href="#">View performance</a>
					                </div><!--col-->
				                </div><!--row-->
						                
			                </div><!--col-->
		                </div><!--row-->
		                <div class="row">
			                <div class="col-12 col-md-6">
					            <div class="bordered-label-content">
						            <label>Skills</label>
						            <p>Skill 1</p>
						            <p>Skill 2</p>
						            <p>Skill 3</p>
					            </div>
				            </div><!--col-->
				            <div class="col-12 col-md-6">
					            <div class="bordered-label-content">
						            <label>Courses</label>
						            <p>Course 1</p>
						            <p>Course 2</p>
						            <p>Course 3</p>
					            </div>
				            </div><!--col-->
			            </div><!--row-->
	                </div><!--profile_presentation-->
                </div><!--col-->
                <div class="col-12 col-lg-6">
					<div class="table-responsive">
	                    <table class="table table-bordered">
	                        <thead>
	                            <tr>
	                                <th scope="col" class="green-content">HHA</th>
	                                <th scope="col" class="green-content">Course progression</th>
	                                <th scope="col" class="green-content">Hours taken</th>
	                                <th scope="col" class="green-content">Questions</th>
	                                <th scope="col" class="green-content">Message</th>
	                            </tr>
	                        </thead>
	
	                        <tbody>
	                            <tr>
	                                <td><strong>Giacomo Guilizzoni</strong></td>
									<td>50%</td>
	                                <td>7</td>
	                                <td>3</td>
	                                <td class="text-center">
		                                <a href="#">
			                                <img width="17" src="http://dev.sozpic.com/maquetas/nevvon/assets/images/icon_envelope_green.svg" />
		                                </a>
	                                </td>
	                            </tr>
	                            <tr>
	                                <td><strong>Giacomo Guilizzoni</strong></td>
									<td>50%</td>
	                                <td>7</td>
	                                <td>3</td>
	                                <td class="text-center">
		                                <a href="#">
			                                <img width="17" src="http://dev.sozpic.com/maquetas/nevvon/assets/images/icon_envelope_green.svg" />
		                                </a>
	                                </td>
	                            </tr>
	                            <tr>
	                                <td><strong>Giacomo Guilizzoni</strong></td>
									<td>50%</td>
	                                <td>7</td>
	                                <td>3</td>
	                                <td class="text-center">
		                                <a href="#">
			                                <img width="17" src="http://dev.sozpic.com/maquetas/nevvon/assets/images/icon_envelope_green.svg" />
		                                </a>
	                                </td>
	                            </tr>
	                            <tr>
	                                <td><strong>Giacomo Guilizzoni</strong></td>
									<td>50%</td>
	                                <td>7</td>
	                                <td>3</td>
	                                <td class="text-center">
		                                <a href="#">
			                                <img width="17" src="http://dev.sozpic.com/maquetas/nevvon/assets/images/icon_envelope_green.svg" />
		                                </a>
	                                </td>
	                            </tr>
	                            <tr>
	                                <td><strong>Giacomo Guilizzoni</strong></td>
									<td>50%</td>
	                                <td>7</td>
	                                <td>3</td>
	                                <td class="text-center">
		                                <a href="#">
			                                <img width="17" src="http://dev.sozpic.com/maquetas/nevvon/assets/images/icon_envelope_green.svg" />
		                                </a>
	                                </td>
	                            </tr>
	                            <tr>
	                                <td><strong>Giacomo Guilizzoni</strong></td>
									<td>50%</td>
	                                <td>7</td>
	                                <td>3</td>
	                                <td class="text-center">
		                                <a href="#">
			                                <img width="17" src="http://dev.sozpic.com/maquetas/nevvon/assets/images/icon_envelope_green.svg" />
		                                </a>
	                                </td>
	                            </tr>
	                            <tr>
	                                <td><strong>Giacomo Guilizzoni</strong></td>
									<td>50%</td>
	                                <td>7</td>
	                                <td>3</td>
	                                <td class="text-center">
		                                <a href="#">
			                                <img width="17" src="http://dev.sozpic.com/maquetas/nevvon/assets/images/icon_envelope_green.svg" />
		                                </a>
	                                </td>
	                            </tr>
	                            <tr>
	                                <td><strong>Giacomo Guilizzoni</strong></td>
									<td>50%</td>
	                                <td>7</td>
	                                <td>3</td>
	                                <td class="text-center">
		                                <a href="#">
			                                <img width="17" src="http://dev.sozpic.com/maquetas/nevvon/assets/images/icon_envelope_green.svg" />
		                                </a>
	                                </td>
	                            </tr>
	                            <tr>
	                                <td><strong>Giacomo Guilizzoni</strong></td>
									<td>50%</td>
	                                <td>7</td>
	                                <td>3</td>
	                                <td class="text-center">
		                                <a href="#">
			                                <img width="17" src="http://dev.sozpic.com/maquetas/nevvon/assets/images/icon_envelope_green.svg" />
		                                </a>
	                                </td>
	                            </tr>
	                            <tr>
	                                <td><strong>Giacomo Guilizzoni</strong></td>
									<td>50%</td>
	                                <td>7</td>
	                                <td>3</td>
	                                <td class="text-center">
		                                <a href="#">
			                                <img width="17" src="http://dev.sozpic.com/maquetas/nevvon/assets/images/icon_envelope_green.svg" />
		                                </a>
	                                </td>
	                            </tr>
	                        </tbody>
	                    </table>
	                </div>
                </div><!--col-->
            </div><!--row-->
            <div class="row">
	            <div class="col-12">
				    <div class="section-title">ADD NEW COURSE</div>
				    <div class="row">
			            <div class="col-12 col-lg-auto">
				            <ul class="tree">
					            <li class="active">
					            	<a href="#">Module 1</a>
					            	<ul>
						            	<li>
						            		<a href="#">Lesson 1</a>
						            	</li>
						            	<li>
						            		<a href="#">Lesson 2</a>
						            	</li>
						            	<li>
						            		<a href="#">Lesson 3</a>
						            	</li>
						            	<li class="add">
						            		<a href="#">
							            		<span>Add new lesson</span>
							            	</a>
						            	</li>
					            	</ul>
					            </li>
					            <li class="added">
					            	<a href="#">Module 2</a>
					            </li>
					            <li class="added">
					            	<a href="#">Module 3</a>
					            </li>
					            <li class="added">
					            	<a href="#">Module 4</a>
					            </li>
					            <li class="add">
					            	<a href="#">Add new module</a>
					            </li>
				            </ul>
				            
			            </div><!--col-->
			            <div class="col-auto flex-fill">
				            <div class="row">
					            <div class="col-12">
						            <div class="input-content">
						            	<input class="input-course-title" placeholder="Course title here..." />
						            </div>
						            <div class="row">
							            <div class="col-auto"><label class="mw-80"><strong>Description</strong></label></div>
							            <div class="col-auto flex-fill"><div class="input-content"><textarea></textarea></div></div>
						            </div>
						            
					            </div><!--col-->
				            </div><!--row-->
				            <div class="row">
				            <div class="col-12 col-lg-6">
					            <div class="row">
						            <div class="col-auto"><label class="mw-80"><strong>Title</strong></label></div>
						            <div class="col-auto flex-fill"><div class="input-content"><input type="text" /></div></div>
					            </div>
					            
					            <div class="row">
						            <div class="col-auto"><label class="mw-80"><strong>Duration</strong></label></div>
						            <div class="col-auto flex-fill"><div class="input-content"><input type="text" /></div></div>
					            </div>
					            
                                <!--
					            <div class="row">
						            <div class="col-auto"><label class="mw-80"><strong>Tags</strong></label></div>
						            <div class="col-auto flex-fill">
							            <div class="tags">
								            <vue-tags-input
										      v-model="tag"
										      :tags="tags"
										      @tags-changed="newTags => tags = newTags"
										    />
							            </div>
								    </div>
					            </div><!--row-->
					            
				            </div><!--col-->
				            <div class="col-4 col-lg-auto flex flex-fill">
					            <div class="bordered-label-content">
						            <label>Files</label>
					            </div>
					            <div class="text-right">
						            <a href="#" class="button dark-button">Upload files</a>
					            </div>
				            </div><!--col-->
			            </div><!--row-->
			            <div class="upload-content">
			            	<div>
				            	<div class="title">
					            	<img src="http://dev.sozpic.com/maquetas/nevvon/assets/images/icons/solid/upload.svg" />
					            	<span>Upload SCORM File</span>
				            	</div>
			            	</div>
			            </div><!--upload_content-->
			            
			            </div>
		            </div><!--row-->
		            <div class="row justify-content-end">
			            <div class="col-auto">
				           <input type="submit" class="button green-button large-button" value="SEND" />
			            </div><!--col-->
		            </div><!--row-->
	            </div>
            </div>

            <div class="row">
                <div class="col-12 col-md-6 ">
	                <div class="h4">Program completion</div>
	                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin id nisl in justo convallis tristique non at lectus. In vestibulum, purus quis porta ultrices.</p>
                    <test-chart :data="chart_data" :options="myoptions" :height="250" />
                </div>
            </div><!--row-->
            
            <div class="row">
	            <div  class="col-12">
					<vue-snotify></vue-snotify>
		            <div class="table-responsive">
	                    <table class="table table-bordered">
	                        <thead>
	                            <tr>
	                                <th scope="col" class="green-content">HHA</th>
	                                <th scope="col" class="green-content">Course progression</th>
	                                <th scope="col" class="green-content">Hours taken</th>
	                                <th scope="col" class="green-content">Questions</th>
	                                <th scope="col" class="green-content">Message</th>
	                            </tr>
	                        </thead>
	
	                        <tbody>
	                            <tr class="completed">
	                                <td><strong>Giacomo Guilizzoni</strong></td>
									<td>50%</td>
	                                <td>7</td>
	                                <td>3</td>
	                                <td class="text-center">
		                                <a href="#">
			                                <img width="17" src="http://dev.sozpic.com/maquetas/nevvon/assets/images/icon_envelope_green.svg" />
		                                </a>
	                                </td>
	                            </tr>
	                            <tr class="completed">
	                                <td><strong>Giacomo Guilizzoni</strong></td>
									<td>50%</td>
	                                <td>7</td>
	                                <td>3</td>
	                                <td class="text-center">
		                                <a href="#">
			                                <img width="17" src="http://dev.sozpic.com/maquetas/nevvon/assets/images/icon_envelope_green.svg" />
		                                </a>
	                                </td>
	                            </tr>
	                            <tr class="partial">
	                                <td><strong>Giacomo Guilizzoni</strong></td>
									<td>50%</td>
	                                <td>7</td>
	                                <td>3</td>
	                                <td class="text-center">
		                                <a href="#">
			                                <img width="17" src="http://dev.sozpic.com/maquetas/nevvon/assets/images/icon_envelope_green.svg" />
		                                </a>
	                                </td>
	                            </tr>
	                            <tr class="completed">
	                                <td><strong>Giacomo Guilizzoni</strong></td>
									<td>50%</td>
	                                <td>7</td>
	                                <td>3</td>
	                                <td class="text-center">
		                                <a href="#">
			                                <img width="17" src="http://dev.sozpic.com/maquetas/nevvon/assets/images/icon_envelope_green.svg" />
		                                </a>
	                                </td>
	                            </tr>	                            <tr class="partial">
	                                <td><strong>Giacomo Guilizzoni</strong></td>
									<td>50%</td>
	                                <td>7</td>
	                                <td>3</td>
	                                <td class="text-center">
		                                <a href="#">
			                                <img width="17" src="http://dev.sozpic.com/maquetas/nevvon/assets/images/icon_envelope_green.svg" />
		                                </a>
	                                </td>
	                            </tr>
	                            <tr class="initial">
	                                <td><strong>Giacomo Guilizzoni</strong></td>
									<td>50%</td>
	                                <td>7</td>
	                                <td>3</td>
	                                <td class="text-center">
		                                <a href="#">
			                                <img width="17" src="http://dev.sozpic.com/maquetas/nevvon/assets/images/icon_envelope_green.svg" />
		                                </a>
	                                </td>
	                            </tr>
	                            <tr class="initial">
	                                <td><strong>Giacomo Guilizzoni</strong></td>
									<td>50%</td>
	                                <td>7</td>
	                                <td>3</td>
	                                <td class="text-center">
		                                <a href="#">
			                                <img width="17" src="http://dev.sozpic.com/maquetas/nevvon/assets/images/icon_envelope_green.svg" />
		                                </a>
	                                </td>
	                            </tr>
	                            <tr class="partial">
	                                <td><strong>Giacomo Guilizzoni</strong></td>
									<td>50%</td>
	                                <td>7</td>
	                                <td>3</td>
	                                <td class="text-center">
		                                <a href="#">
			                                <img width="17" src="http://dev.sozpic.com/maquetas/nevvon/assets/images/icon_envelope_green.svg" />
		                                </a>
	                                </td>
	                            </tr>
	                            <tr>
	                                <td><strong>Giacomo Guilizzoni</strong></td>
									<td>50%</td>
	                                <td>7</td>
	                                <td>3</td>
	                                <td class="text-center">
		                                <a href="#">
			                                <img width="17" src="http://dev.sozpic.com/maquetas/nevvon/assets/images/icon_envelope_green.svg" />
		                                </a>
	                                </td>
	                            </tr>
	                            <tr>
	                                <td><strong>Giacomo Guilizzoni</strong></td>
									<td>50%</td>
	                                <td>7</td>
	                                <td>3</td>
	                                <td class="text-center">
		                                <a href="#">
			                                <img width="17" src="http://dev.sozpic.com/maquetas/nevvon/assets/images/icon_envelope_green.svg" />
		                                </a>
	                                </td>
	                            </tr>
	                        </tbody>
	                    </table>
	                </div>
	            </div>
            </div>
        
				</div><!--col-->
			</div><!--row-->
		</div><!--container_fluid-->
    </section>
</template>

<script>
import TestChart from './../charts/TestChart.js';


function notificador(){
	alert('test');
}

export default {

    components : {
        TestChart
    },

    data() {
        return {
	        
			  onClick: function(){
	              alert('eee')
              },
            chart_data : {
		            
	                labels: ["Azahara", "Robert", "Fran", "Paco", "Duar"],
			        links: ['http://google.es','http://google.es','http://google.es','http://google.es','http://marca.com'],
			      datasets: [
			        {
			          label: '',
			          backgroundColor: ["#3e95cd", "#8e5ea2","#3cba9f","#e8c3b9","#c45850"],
			          data: [30,20,54,25,12]
			        }
			      ]
              },
              myoptions:{
	            onClick:function(evt){
	                var activePoints = this.getElementsAtEvent(evt);
		            var firstPoint = activePoints[0];
					var link = this.data.links[firstPoint._index];
					alert(link);
	            },
	            responsive: false
	            
	        }
           }
    },
    methods: {
	    displayNotification: function(){
			this.$snotify.success('Holi', {
				timeout: 2000,
				showProgressBar: true,
				closeOnClick: false,
				pauseOnHover: true
			});
	    },
	    graphClickEvent: function(event, array){
		    alert('yee');
		}

    }
};


</script>
<style lang="css">

.tags .vue-tags-input{
	max-width: none !important;
	margin-bottom: 30px;
}
.tags .vue-tags-input .input{
	padding: 10px;
}
.tags .tag.valid {
  background-color: #48a5a9;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/AdminMockupsComponent.vue